import React, { useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import classes from './index.module.scss';
import Preview_One from '../../../assets/images/video-preview-one.jpg';
import { Link } from 'react-router-dom';
import Video from '../../UI/Video';

const About = () => {
  const [visibility, setVisibility] = useState({
    video_one: true,
    video_two: true
  });

  const startPlayerHandler = (name) => {
    setVisibility({
      ...visibility,
      [name]: false
    });
  }

  return (
    <div className={classes.About}>
      <Container>
        <Row>
          <Col>
            <h3 className={classes.About_Title}>
              about
            </h3>
          </Col>
        </Row>
        <Row className="mb-5">
          <Col lg={5}>
            <h2 className={classes.About_Sub_Title}>
              How does<br /> MatchForce work?
            </h2>
          </Col>
          <Col lg={7}>
            <p className={classes.About_Description}>
              MatchForce matches North Carolina businesses to government contracts, and government purchasers to NC suppliers. 
              Businesses, contracting officers and purchase card holders can register, post, search and receive opportunities - and get results - TODAY!”
            </p>
          </Col>
        </Row>
        <Row className="mb-5">
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_One}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_one}
              title="About MatchForce.org"
              name="video_one"
              link="https://www.youtube.com/watch?v=KGU2GKuRLsM&ab_channel=NCMBCHQ"
            />
          </Col>
          <Col lg={6} className="mb-4">
            <Video 
              preview={Preview_One}
              startPlayerHandler={startPlayerHandler}
              visibility={visibility.video_two}
              title="MatchForce.org: Getting Started"
              name="video_two"
              link="https://www.youtube.com/watch?v=M0oyQg2DAo0&ab_channel=NCMBCHQ"
            /> 
          </Col>
        </Row>
        <Row>
          <Col className="text-center">
            <Link
              to="/videos"
              className={classes.See_More_Videos}
            >
              See More Videos
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default About;